import { render, staticRenderFns } from "./ChatBar.vue?vue&type=template&id=c9cf35f0&scoped=true"
import script from "./ChatBar.vue?vue&type=script&lang=js"
export * from "./ChatBar.vue?vue&type=script&lang=js"
import style0 from "./ChatBar.vue?vue&type=style&index=0&id=c9cf35f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf35f0",
  null
  
)

export default component.exports